import React, { Component } from 'react';
import Grid from '../../Utils/GridDocumento';
import { standardActions } from '../../Utils/GridAbono/StandardActions';
import moment from 'moment';

class SalidasModDetalle extends Component{
    
    render(){
        const { loader, eliminarDocumento, detalle } = this.props;
        return(
            <React.Fragment>
                {detalle &&
                    <Grid 
                        hover 
                        striped 
                        data={detalle} 
                        loading={loader}
                        headerStyle={ { background: 'black' } } 
                        //onSortChange={onSortChange} 
                    >
                    <TableHeaderColumn
                        isKey
                        dataField="fecha"
                        width="150"
                        dataFormat={(cell, row)=>{
                            return moment(cell).format("DD/MM/YYYY");
                        }}
                        dataSort
                        thStyle={ 
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Fecha
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="serie"
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Serie
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="numero"
                        headerAlign="center"
                        dataAlign='right'
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Numero
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        thStyle={
                        {color: 'white'}}
                        dataField="id"
                        width="150"
                        dataAlign="center"
                        dataSort
                        dataFormat={standardActions({
                            eliminar: eliminarDocumento })} 
                    >
                        Acciones
                    </TableHeaderColumn>
               </Grid>
                }
            </React.Fragment>
        );
    }
}

export default SalidasModDetalle;
